<!-- 批量选型-风机盘管 -->
<template>
  <div id="ProductList" class="page product-list">
    <div class="content-box">
      <fan-coil-search
          ref="fanCoilSearch"
          :temperature-min="summerTemperatureMin"
          :temperature-max="winterTemperatureMax"
      />
      <el-table
        :data="tableData"
        v-if="tableData.length"
        :row-style="{ height: '40px' }"
        :cell-style="cellStyle"
        :height="tableHeight"
        v-loading="isLoading"
        border
        :span-method="objectSpanMethod"
      >
        <el-table-column prop="roomCode" label="房间编号">
          <template v-slot="{ row }">
            {{ row.roomCode || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="房间名称">
          <template v-slot="{ row }">
            {{ row.roomName || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomArea" label="房间面积 (㎡)">
          <template v-slot="{ row }">
            {{ row.roomArea || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="calEquipmentNumber"
          label="计算台数"
          width="72px"
        >
          <template v-slot="{ row }">
            {{ row.calEquipmentNumber || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          label="指定台数"
          width="140px"
          align="center"
          prop="equipmentNumber"
        >
          <template slot-scope="scope">
            <el-input-number
              width="110px"
              :min="1"
              :precision="0"
              @change="numberChange(scope.row)"
              v-model="scope.row.equipmentNumber"
              placeholder="不指定"
            />
          </template>
        </el-table-column>
        <el-table-column prop="model" label="设备型号">
          <template v-slot="{ row }">
            <span v-if="isHasBestRoom">{{ row.model || "- -" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="medium_air_flow"
          :render-header="renderHeader"
          :label="medium_air_flow"
          width="72px"
        >
          <template v-slot="{ row }">
            {{ row.medium_air_flow || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_total_heat"
          :render-header="renderHeader"
          :label="medium_total_heat"
        >
          <template v-slot="{ row }">
            {{ row.medium_total_heat || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_sensible_heat"
          :render-header="renderHeader"
          :label="medium_sensible_heat"
        >
          <template v-slot="{ row }">
            {{ row.medium_sensible_heat || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_latent_heat"
          :render-header="renderHeader"
          :label="medium_latent_heat"
        >
          <template v-slot="{ row }">
            {{ row.medium_latent_heat || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_cooling_heating_and_humidity_ratio"
          :render-header="renderHeader"
          :label="medium_cooling_heating_and_humidity_ratio"
        >
          <template v-slot="{ row }">
            {{ row.medium_cooling_heating_and_humidity_ratio || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_heating"
          :render-header="renderHeader"
          :label="medium_heating"
        >
          <template v-slot="{ row }">
            {{ row.medium_heating || "- -" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="94px">
          <template slot-scope="scope">
            <el-button
              @click="chooseDetail(scope.row, 'detail')"
              style="margin-left: 16px"
              type="text"
              size="small"
              :disabled="buttonIsShow || isHasBestCode.includes(scope.$index) || !scope.row.productIds"
            >查看详情</el-button>
            <el-button
              @click="chooseOthers(scope.row, 'others', scope.$index)"
              type="text"
              size="small"
              :disabled="buttonIsShow"
            >重新选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <empty-content text="暂无房间信息" v-else />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        :append-to-body="true"
        :modal="true"
        @open="handleOpen"
        :before-close="handleClose"
        :destroy-on-close="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
        :custom-class="buttonType === 'detail'?'product-detail-drawer':''"
      >
        <template v-if="buttonType !== 'detail'" #title>
          <span>{{ currentRow.roomName }}</span>
        </template>
        <div style="height: 100%;">
          <fan-coil-detail v-if="buttonType === 'detail'" :productIds="productIds"/>
          <fan-coil-others
            v-else
            ref="FanCoilOthers"
            :room="currentRoomInfo"
            :product-row="productRow"
            :current-row="currentRow"
            :row-search="currentRowSearchData"
            @selectRow="getRow"
          />
        </div>
      </el-drawer>
      <!-- 一键选型 -->
      <div class="button-footer">
        <el-button class="lectotype" @click="chooseMsg">一键选型</el-button>
        <el-button
          class="confirm"
          @click="confirmAction()"
          :class="buttonIsShow ? 'active' : 'noActive'"
          :disabled="buttonIsShow"
          >确认方案</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FanCoilSearch from './components/batchSelection/FanCoilSearch.vue'
import FanCoilDetail from './FanCoilDetail.vue'
import FanCoilOthers from './FanCoilOthers.vue'
import {
  GetEquipmentBatchSelectionArguments,
  SetEquipmentBatchSelectionResults,
  GetGdcAccessToken,
} from '@/core/gcsUtils'
import EmptyContent from '@/components/business/EmptyContent'

export default {
  name: 'FanCoil',
  components: {
    FanCoilSearch,
    FanCoilDetail,
    FanCoilOthers,
    EmptyContent,
  },
  data() {
    return {
      isFirstChoose: true,
      fanCoilSearch: {},
      // 点击重新选择的房间的信息
      currentRoomInfo: {},
      buttonIsShow: true,
      isLoading: false,
      buttonType: '',
      drawer: false,
      innerDrawer: false,
      direction: 'ltr',
      drawerWidth: '1120px',
      pageSize: 50,
      // 挡位切换
      isMediumLevel: true,
      tableData: [],
      tableDataCopy: [],
      tableDataCopyChoose: [],
      detailId: '',
      productIds: '', // 产品ID
      productRow: [],
      currentRow: [],
      currentRowSearchData: {},
      currentValue: [],
      currentId: '',
      selectVal: {},
      inputCondition: [],
      medium_air_flow: '中档风量 || (㎡/h)',
      medium_total_heat: '中档全冷 || (kW)',
      medium_sensible_heat: '中档显冷 || (kW)',
      medium_latent_heat: '中档潜冷 || (kW)',
      medium_cooling_heating_and_humidity_ratio: '中档制冷热 || 湿比(kJ/kg)',
      medium_heating: '中档制热 || (kW)',
      isChangeRow: false,
      currentIndex: '',
      isHasBestRoom: true,
      isHasBestCode: [],
      result: [],
      resultData: [],
      confirmTableData: [],
      // confirmProductIds: [],
      summerTemperatureMin: '',
      winterTemperatureMax: '',
      tableHeight: null,
      // 品类编码
      gjwCategoryCode: 'C000006',
      // 品类名称
      gjwCategoryName: '风机盘管',
      g_c_default_condition: true,
      g_c_selection_best_result: [],
      g_c_selection_alternative_result: [],
    }
  },

  created() {
    // 获取机电数据
    this.getEquipmentBatchSelectionArguments()
    // 获取品牌
    this.loadBrands({ gjwCategoryCode: this.gjwCategoryCode })
    // 获取筛选
    this.loadAggProperties({ gjwCategoryCode: this.gjwCategoryCode })
  },

  mounted() {
    // 访问批量选型埋点
    this.$tracks({
      event: 'visitBachSelection',
      params: {
        g_c_class_code: this.gjwCategoryCode,
        g_c_class_name: this.gjwCategoryName,
      },
    })
    this.tableHeight = document.body.clientHeight - 184
    // 窗口重置时候，重新获取高度
    window.onresize = () => {
      return (() => {
        this.tableHeight =
          document.body.clientHeight > 750
            ? document.body.clientHeight - 205
            : document.body.clientHeight - 190
      })()
    }
  },

  methods: {
    ...mapMutations({
      setProductId: 'productDetail/setProductId',
      setUserToken: 'user/setUserToken',
    }),

    ...mapActions({
      // 获取品牌
      loadBrands: 'list/loadBrands',
      // 获取筛选
      loadAggProperties: 'fanList/loadAggProperties',
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    // 获取机电数据
    async getEquipmentBatchSelectionArguments() {
      const projectInfoStr = await GetEquipmentBatchSelectionArguments()
      // 设置token
      const { data: gToken } = await GetGdcAccessToken()
      this.setUserToken(gToken || null)
      const that = this
      // 获取机电数据
      that.inputCondition = projectInfoStr.data || []
      // that.inputCondition = [
      //   {
      //     airSupplyVolume: 340,
      //     coolingHeatingAndHumidityRatio: 1,
      //     heatingCapacity: 20,
      //     roomArea: 200,
      //     roomCode: '00one',
      //     roomId: '001',
      //     roomName: '1号房',
      //     sensibleHeat: 20,
      //     summerDryBulbTemperature: 50,
      //     summerWetBulbTemperature: 40,
      //     totalHeat: 100,
      //     winterDryBulbTemperature: 20
      //   },
      //   {
      //     airSupplyVolume: 300,
      //     coolingHeatingAndHumidityRatio: 1,
      //     heatingCapacity: 20,
      //     roomArea: 140.11232000000001,
      //     roomCode: '00TWO',
      //     roomId: '002',
      //     roomName: '2号房',
      //     sensibleHeat: 20,
      //     summerDryBulbTemperature: 20,
      //     summerWetBulbTemperature: 30,
      //     totalHeat: 100,
      //     winterDryBulbTemperature: 40
      //   },
      // ]
      that.confirmTableData = that.inputCondition

      // 获取夏季温度数值集合
      const summerTemperature = []
      that.inputCondition.forEach((v) => {
        summerTemperature.push(v.summerDryBulbTemperature)
        summerTemperature.push(v.summerWetBulbTemperature)
      })

      that.summerTemperatureMin = Math.min.apply(null, summerTemperature)
      // 获取冬季温度数值集合
      const winterTemperature = []
      that.inputCondition.forEach((v) => {
        winterTemperature.push(v.winterDryBulbTemperature)
      })

      that.winterTemperatureMax = Math.max.apply(null, winterTemperature)
      that.tableData = JSON.parse(JSON.stringify(that.inputCondition))
      that.tableData.forEach((v) => {
        that.tableDataCopy.push(v)
        that.tableDataCopy.push(JSON.parse(JSON.stringify(v)))
      })
      this.tableData = that.tableDataCopy
      this.tableData.forEach((v, index) => {
        if ((index + 1) % 2 === 0) {
          v.model = '计算修正值：'
        }
      })
    },

    // 列表头换行
    renderHeader(h, { column, $index }) {
      const columnArr = column.label.split('||') // 此处换行标志
      if (columnArr.length >= 2) {
        const divArr = []
        columnArr.map((item) => {
          divArr.push(h('div', { style: 'text-align: center ' }, item))
        })
        return h('div', {}, divArr)
      }
      return h('div', {}, column.label)
    },

    // 合并单元行
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 5 || column.label === '操作') {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },

    // 设置行样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (rowIndex % 2 !== 0) {
        cellStyle = 'background:#F5F7FA;color: #7087AA;'
      }
      if (row.model === '未找到合适型号' && columnIndex > 4) {
        cellStyle = 'color: #E9AB39;'
      }
      return cellStyle
    },
    // 一键选型
    chooseMsg() {
      if (this.isFirstChoose) {
        this.isFirstChoose = false
        this.confirmChooseMsg()
      } else {
        this.$confirm('再次选型将覆盖已有数据，是否确认再次批量选型？', '确认提示', {
          type: 'warning',
          customClass: 'customClass',
        }).then(() => {
          this.confirmChooseMsg()
        }).catch(() => {})
      }
    },
    confirmChooseMsg() {
      this.isLoading = true
      const data = this.$refs.fanCoilSearch.getSearchData()
      this.isMediumLevel = data.isMediumLevel
      this.fanCoilSearch = data.searchData
      this.g_c_default_condition = data.g_c_default_condition
      const productProperties = data.productProperties
      const validationProperties = data.validProperties
      const nonValidationProperties = data.nonValidProperties
      // 切换表头
      const letter = this.isMediumLevel ? '中' : '高'
      this.medium_air_flow = `${letter}档风量 || (㎡/h)`
      this.medium_total_heat = `${letter}档全冷 || (kW)`
      this.medium_sensible_heat = `${letter}档显冷 || (kW)`
      this.medium_latent_heat = `${letter}档潜冷 || (kW)`
      this.medium_cooling_heating_and_humidity_ratio = `${letter}档制冷热 || 湿比(kJ/kg)`
      this.medium_heating = `${letter}档制热 || (kW)`
      this.buttonIsShow = false
      this.isHasBestCode = []
      const paramsForMulti_room = {
        topSize: this.pageSize,
        brandCode: this.fanCoilSearch.brandCode,
        inputCondition: this.inputCondition,
        dustCorrectionFactor: this.isMediumLevel ? null : this.fanCoilSearch.dustCorrectionFactor,
        intermittentUseFactor: this.isMediumLevel ? null : this.fanCoilSearch.intermittentUseFactor,
        level: this.fanCoilSearch.level,
        productProperties: productProperties,
        validationProperties: validationProperties,
        nonValidationProperties: nonValidationProperties,
        singleUnitResponsibilityArea: this.fanCoilSearch.singleUnitResponsibilityArea,
        summerSupplyWaterTemperature: this.fanCoilSearch.summerSupplyWaterTemperature,
        winterSupplyWaterTemperature: this.fanCoilSearch.winterSupplyWaterTemperature,
      }
      // console.log(paramsForMulti_room, 11)
      this.$api.products.getMulti_room(this.gjwCategoryCode, paramsForMulti_room).then((res) => {
        const that = this
        that.tableData = res
        // 获取一键选型中返回的备选结果id列表
        that.g_c_selection_best_result = []
        that.g_c_selection_alternative_result = []
        res.forEach((v) => {
          if (v.id) {
            that.g_c_selection_best_result.push({
              roomId: v.roomId,
              productId: v.id,
            })
            that.g_c_selection_alternative_result.push({
              roomId: v.roomId,
              productId: v.productIds,
            })
          }
        })
        // 属性筛选：一键筛选参数（全局筛选条件）只包含筛选条件的内容，不包含机电穿过的
        delete paramsForMulti_room.inputCondition
        // 批量选型埋点
        this.$tracks({
          event: 'batchSelection',
          params: {
            g_c_class_code: this.gjwCategoryCode,
            g_c_class_name: this.gjwCategoryName,
            g_c_brand_code: that.fanCoilSearch.brandCode,
            g_c_brand_name: that.fanCoilSearch.brandName,
            // 选型初始条件： 机电传入数据
            g_c_selection_initial_condition: that.inputCondition,
            // 属性筛选：一键筛选参数（全局筛选条件）
            g_c_property: paramsForMulti_room,
            // 是否缺省条件：一键选型中增加全局筛选则为false,默认为true
            g_c_default_condition: this.g_c_default_condition,
            // 最优选项结果：列表数据
            g_c_selection_best_result: that.g_c_selection_best_result,
            // 备选结果：一键选型中返回的备选结果id列表
            g_c_selection_alternative_result: that.g_c_selection_alternative_result,
            // 批量个数：房间的个数
            g_c_batch_numbers: that.inputCondition.length,
            // 批量成功个数：有最优选的房间的个数
            g_c_batch_success_numbers: that.g_c_selection_best_result.length,
          },
        })
        that.resultData = JSON.parse(JSON.stringify(res))
        that.tableDataCopyChoose = []
        that.tableData.forEach((v) => {
          // 优先展示指定设备台数
          if (!v.equipmentNumber) {
            v.equipmentNumber = undefined
          } else {
            v.calEquipmentNumber = '- -'
          }
          that.tableDataCopyChoose.push(v)
          that.tableDataCopyChoose.push(JSON.parse(JSON.stringify(v)))
        })
        const tableCopy = JSON.parse(JSON.stringify(that.tableDataCopy))
        tableCopy.forEach((v, index) => {
          that.tableDataCopyChoose.forEach((j, index) => {
            if (v.roomId === j.roomId) {
              tableCopy[index] = that.tableDataCopyChoose[index]
            }
          })
        })

        tableCopy.forEach((v, index) => {
          if ((index + 1) % 2 === 0) {
            v.selectionParameter = v.correctionParameter
            v.model = '计算修正值：'
          }
          if (!v.model) {
            v.model = '未找到合适型号'
            this.isHasBestRoom = false
            this.isHasBestCode.push(index)
          } else {
            this.isHasBestRoom = true
          }
        })
        that.tableData = tableCopy
        that.tableData.forEach((v) => {
          // 一键选型时，将批量查询条件内置到每个房间
          v.searchData = { ...this.fanCoilSearch, validChecked: [...this.fanCoilSearch.validChecked] }
          if (!v.selectionParameter) return
          if (this.isMediumLevel) {
            v.selectionParameter.forEach((j) => {
              j.name === '中档风量' && (v.medium_air_flow = j.value)
              j.name === '中档全冷' && (v.medium_total_heat = j.value)
              j.name === '中档显冷' && (v.medium_sensible_heat = j.value)
              j.name === '中档制热' && (v.medium_heating = j.value)
              j.name === '中档制冷热湿比' && (v.medium_cooling_heating_and_humidity_ratio = j.value)
              j.name === '中档潜冷' && (v.medium_latent_heat = j.value)
            })
          } else {
            v.selectionParameter.forEach((j) => {
              j.name === '高档风量' && (v.medium_air_flow = j.value)
              j.name === '高档全冷' && (v.medium_total_heat = j.value)
              j.name === '高档显冷' && (v.medium_sensible_heat = j.value)
              j.name === '高档制热' && (v.medium_heating = j.value)
              j.name === '高档制冷热湿比' && (v.medium_cooling_heating_and_humidity_ratio = j.value)
              j.name === '高档潜冷' && (v.medium_latent_heat = j.value)
            })
          }
        })
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
        this.$msgbox(
          '存在不合理的输入值，请检查是否符合实际情况并重新输入。',
          '提示',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
            },
          }
        )
      })
    },

    // 确认方案
    confirmAction() {
      const changeModel = JSON.parse(JSON.stringify(this.tableData))
      const recetModel = []
      const confirmProductIds = []
      changeModel.forEach((v) => {
        v.model !== '计算修正值：' && recetModel.push(v)
      })
      this.resultData.forEach((v) => {
        recetModel.forEach((j) => {
          if (v.roomId === j.roomId) {
            v.model = j.model
            v.id = j.id
            v.name = j.name
            confirmProductIds.push(j.id)
          }
        })
      })
      const parameter_values = {
        paramsObj: { productIds: confirmProductIds },
        parameter_filter: 'GMEP_PARAMETER',
      }
      this.$api.products.parameter_values(parameter_values).then((res) => {
        const data = res
        // console.log('res:', res)
        const that = this
        that.result = []
        that.resultData.forEach((v) => {
          if (!v.id) {
            that.result.push({
              roomArea: v.roomArea,
              roomCode: v.roomCode,
              roomId: v.roomId,
              roomName: v.roomName,
              equipmentNumber: v.equipmentNumber || v.calEquipmentNumber,
            })
          }
          data.forEach((j) => {
            if (v.id && v.id === j.id) {
              that.result.push({
                roomArea: v.roomArea,
                roomCode: v.roomCode,
                roomId: v.roomId,
                roomName: v.roomName,
                equipmentNumber: v.equipmentNumber || v.calEquipmentNumber,
                productId: v.id,
                productModel: v.model,
                productName: v.name,
                parameters: j.parameters,
              })
            }
          })
        })
        const g_c_confirm_best_result = []
        that.result.forEach((v) => {
          if (v.productId) {
            g_c_confirm_best_result.push({
              roomId: v.roomId,
              productId: v.productId,
            })
          }
        })
        // console.log('that.result:', that.result)
        // 确认批量选型结果埋点
        this.$tracks({
          event: 'confirmBatchSelection',
          params: {
            g_c_class_code: this.gjwCategoryCode,
            g_c_class_name: this.gjwCategoryName,
            // 最优选项结果：列表数据
            g_c_selection_best_result: g_c_confirm_best_result,
            // 批量个数：房间的个数
            g_c_batch_numbers: that.inputCondition.length,
            // 批量成功个数：有最优选的房间的个数
            g_c_batch_success_numbers: that.g_c_selection_best_result.length,
          },
        })
        SetEquipmentBatchSelectionResults(that.result)
      })
    },

    // 抽屉弹出事件
    handleOpen() {
      if (this.buttonType === 'detail') {
        // 获取产品详情
        this.setProductId(this.productIds)
        this.loadProperties()
        this.loadDetail()
        this.loadRelatedComponents()
        this.loadRelatedBlocks()
      }
    },

    // 抽屉事件
    handleClose(done) {
      if (this.buttonType !== 'detail' && this.isChangeRow) {
        this.$confirm(
          '是否确认选择 ' + this.selectVal.model + ' ?',
          '选择确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '放弃修改',
            type: 'warning',
            customClass: 'customClass',
          }
        )
          .then(() => {
            this.$message({
              message: '选型结果已更新',
              type: 'success',
            })
            this.changeRow()
            done()
          })
          .catch(() => {
            this.isChangeRow = false
            done()
          })
      } else {
        done()
      }
    },

    // 获取行数据
    getRow({ row, index }) {
      this.detailId = row.id
      this.isChangeRow = true
      this.selectVal = row
      this.selectIndex = index
    },

    // 更改行数据
    changeRow() {
      const index = this.currentIndex
      if (this.selectVal) {
        this.tableData[index] = {
          ...this.tableData[index],
          ...this.selectVal,
        }
      }
      this.currentValue.push(
        { value: this.selectVal.medium_air_flow },
        { value: this.selectVal.medium_total_heat },
        { value: this.selectVal.medium_sensible_heat },
        { value: this.selectVal.medium_latent_heat },
        { value: this.selectVal.medium_cooling_heating_and_humidity_ratio },
        { value: this.selectVal.medium_heating }
      )
      const that = this
      this.tableData.forEach((v, index) => {
        if (v.id === that.currentId && index % 2 === 0) {
          v.selectionParameter = that.currentValue
        }
      })
    },
    // 查看详情
    async chooseDetail(row, type) {
      this.buttonType = type
      this.currentRow = row
      // 获取产品ID
      this.productIds = row.id
      this.drawer = true
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
          g_c_source: 'batchSelection',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },

    // 重新选择
    chooseOthers(row, type, index) {
      // console.log('row:', row)
      this.isChangeRow = false
      this.currentRow = row
      this.currentRowSearchData = { ...row.searchData }
      this.currentRoomInfo = this.inputCondition.find((it) => it.roomId === row.roomId) || {}
      this.productRow = JSON.parse(JSON.stringify(row.productIds))
      this.currentId = row.id
      // 记录当前选取行
      this.currentIndex = index
      this.buttonType = type
      this.drawer = true
    },

    // 计算台数改变事件
    numberChange(v) {
      const changeRow = v
      this.inputCondition.forEach((v) => {
        if (v.roomId === changeRow.roomId) {
          v.equipmentNumber = changeRow.equipmentNumber
        }
      })
    },
  },

  computed: {
    ...mapGetters({
      brands: 'list/brands',
    }),
  },
}
</script>

<style>
.customClass .el-icon-warning {
  color: #409eff !important;
}
</style>

<style lang="less" scoped>
.product-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
}

/deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}

/deep/.content-box .has-gutter tr {
  height: 50px !important;
}

/deep/.content-box .el-table__header-wrapper {
  height: 50px !important;
}

/deep/.el-table__row {
  height: 40px !important;
}

/deep/.el-table th {
  padding: 0 !important;
}

/deep/.el-table td {
  padding: 0 !important;
}

/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}

/deep/.el-button {
  margin-left: 0 !important;
}

/deep/.el-button--text {
  color: #4897f5;
}

.button-footer {
  text-align: right;
}

.button-footer .el-button {
  color: #fff;
  margin: 8px;
  width: 120px;
  height: 32px;
  border-radius: 2px;
}

.lectotype {
  color: #fff;
  background: #409eff;
}

.lectotype:focus {
  background: #409eff;
}

.lectotype:hover {
  background: #409eff;
}

.active {
  color: #ccc !important;
  border-color: #ccc !important;
}

.noActive {
  color: #409eff !important;
  border-color: #409eff !important;
}
</style>
